<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX19EM6CySc1COijQA80WKBjvNP+0I64BJa4=","cpf":"U2FsdGVkX1/jShSXM/bcb9BQC3luS1hzPrhfR43wL+0="},{"num_cand":"U2FsdGVkX19vg7PyN0Eq2gisHWpJQvI6lC4TNpWXYwU=","cpf":"U2FsdGVkX1+/4T1fRgPO6G1xtgdMVQpataHfIdrumGo="},{"num_cand":"U2FsdGVkX18f/zD1K7iuV8mJq3ylKAEPXMyBWMNt7NE=","cpf":"U2FsdGVkX19x3DwzomSnyYs7NRkWwOcds9Tr7tkT93w="},{"num_cand":"U2FsdGVkX18c0M/f+YBvj8AqmmwsFu1+ELnjAPfnQtU=","cpf":"U2FsdGVkX1+wl59cvrR27DrCp4R+J5/WjClIUBdBu1M="},{"num_cand":"U2FsdGVkX19ys2ZhxOuSnRep0eLj3xxNsaOJTHeyKio=","cpf":"U2FsdGVkX1+w0RGHz5cQs1UJsreloBbyYfMbUH2zRkk="},{"num_cand":"U2FsdGVkX1/u8tbTs5BAp/XeWm7YQtiAwglM9EeUAak=","cpf":"U2FsdGVkX18qv4hDRz4miQ5Rf4FWwcVk0hlZZ0byZsY="},{"num_cand":"U2FsdGVkX18q8SzrHU8ji7b89uTq4zQbju7rwMMYwwU=","cpf":"U2FsdGVkX19Q3Dt1I10lv2Bml6OqxRZth9IVbow54qg="},{"num_cand":"U2FsdGVkX19m3LqHkQBbG49NYB080uhT24HevnwKhGA=","cpf":"U2FsdGVkX1/aL8X82Rt5rEPhiIEynGTvXf2fjF9EWzI="},{"num_cand":"U2FsdGVkX1/vb/XuUwKZVakTdehzKJdfb89IbX/DNGg=","cpf":"U2FsdGVkX18khHfd6WjWeRkfbhFwuTwDN2qtbOqKiPU="},{"num_cand":"U2FsdGVkX1+BkM8PdO37ER5Kuz58BGn4Auf3CUsv6EQ=","cpf":"U2FsdGVkX18N/6xb0rM17GMYGmauJDOZSyzWw6tqvuI="},{"num_cand":"U2FsdGVkX1+yKxP4hl/+Q0bvF71RPENWXvDHUEpqEQ0=","cpf":"U2FsdGVkX19pIVx8iQAoSMBuJQEifZO+OIe19tlm8VA="},{"num_cand":"U2FsdGVkX196WCgd4TBHgYaqp0Mc7vrwI6szZUsXKSc=","cpf":"U2FsdGVkX1/R4/o0SNl+ulATYLm+AmzJ17OqLivPH+Y="},{"num_cand":"U2FsdGVkX1/IRmegaJKMuoaL0BUxVN8sJv3YYJA3Qgw=","cpf":"U2FsdGVkX19dAhLFGiazt6EFdpA93WamWsSzTunFo/g="},{"num_cand":"U2FsdGVkX18NXB826+2FjW/ATCZCGvp8SdTuTOKW2vk=","cpf":"U2FsdGVkX19rma7ysrqG5ydBeOayrZZ0w8Y8/pDnDjY="},{"num_cand":"U2FsdGVkX18T6gQgMyMt+YO4bCSsVqKiLxM8UIgJjNU=","cpf":"U2FsdGVkX1+REDHiWb/2+dimDDdz93tZSi1DkMl5ihI="},{"num_cand":"U2FsdGVkX19I3nCB7LhqF25ir84G2djqrmMeuvh1zmg=","cpf":"U2FsdGVkX1/YnBGZ2i2OtytrH3N837/LD+xbwzqpHIk="},{"num_cand":"U2FsdGVkX19t1F98JS6OZgohMNXVT28Ub5Y4cmeynuc=","cpf":"U2FsdGVkX19nM6DL+rSdGaPtRutumsVsSQlzberuqX0="},{"num_cand":"U2FsdGVkX190JAjLYsyP7HxXjj2fu7AxqjVqqrch91A=","cpf":"U2FsdGVkX1+Jw1mKWTN/9IuxmSCPFRQUkzR5WKlUvJ8="},{"num_cand":"U2FsdGVkX18vihStCR8BrZm5AsGM7+N1zCNlofaJxbs=","cpf":"U2FsdGVkX1+1DQjt8KMZ4SmPvFRXYVsBsNsTlyAGb7k="},{"num_cand":"U2FsdGVkX1/W2gt8P98jgv59Hpm/ehMEwRHNieASpsk=","cpf":"U2FsdGVkX1+P/I0wdauvQCvPC1iLVwiqFVcEIhJd+tc="},{"num_cand":"U2FsdGVkX1813wkTwnRQ5BsIoy7guxv/Awa2mlhRm3k=","cpf":"U2FsdGVkX1+odhE5TWPZqkTuyGaqtXmyYe1uJEYcIf0="},{"num_cand":"U2FsdGVkX1+/0uuxnnH2LP0YtUB9+5gIiMzI62mLZPw=","cpf":"U2FsdGVkX1+gzNuwBkjAtVD+ra5yZxzehDKDeSVpbQU="},{"num_cand":"U2FsdGVkX184+dhlrd8n1UGu8n7NCPQaVdF98mUvxTU=","cpf":"U2FsdGVkX19yKV5mhn/gDH5FJVN3MLq8pRLZBwLhjQk="},{"num_cand":"U2FsdGVkX1/F8A69WfZ1M+7I2NlZNw4F/l2vA4NzPoM=","cpf":"U2FsdGVkX1+u/HrTD77Jsgjh8oCbv7MGeYvTiQHcMQw="},{"num_cand":"U2FsdGVkX19+LpaAO2P21Uzt7BaQ6A2BfEawi58VKC8=","cpf":"U2FsdGVkX183BOoNBeB5Dyt+16b56SSxKVNmwY+NY/0="},{"num_cand":"U2FsdGVkX195nRRjlLwewHJ9KdOxTsUUnLNt8GmtPZw=","cpf":"U2FsdGVkX1+HUQvgw8pNJmk9PLJcglVUVDf3E74sGBo="},{"num_cand":"U2FsdGVkX1/MP87tQuP8UYSim/Daf7DhlY68jZHhj4M=","cpf":"U2FsdGVkX1891SFH2Jx4OEQkk1uSsDEZLI6wuw2fubk="},{"num_cand":"U2FsdGVkX18w+Ps+WB3B5z+fYFeDAmhhGFbXaOxwTq8=","cpf":"U2FsdGVkX19IK0EHrr4YVqhtlEQE4d7s7uDAScGT2+8="},{"num_cand":"U2FsdGVkX1+k4hHaEcLbk6NU/fVzNQMxmsyGxlbHzFw=","cpf":"U2FsdGVkX18Yz4rgittAhZa9mHJtgWMP12dwIYV+Qvk="},{"num_cand":"U2FsdGVkX19ixXUc8BhFZr3r/t1/hjcFpvkk6Dij4KY=","cpf":"U2FsdGVkX1/MXejJIai+kRVLSfwGEQ0Uds6MrloFEWg="},{"num_cand":"U2FsdGVkX1/qwD1xbr0P1FhDdC9MONpyuXjCGMN6VPI=","cpf":"U2FsdGVkX1+5dYtt+50Ss3N0jlDkDOQtPnDAxUnoUoo="},{"num_cand":"U2FsdGVkX19xIkVC5BymAQBkkwXKPLlX5NOSXlsDKG8=","cpf":"U2FsdGVkX185hsmPV4su6iA3sAWo+FKE++npcQoDqKI="},{"num_cand":"U2FsdGVkX18SZoO1/5hGa6Zwvtzqith3oz9KMywI6nU=","cpf":"U2FsdGVkX19UIKG7znmKvFoW1+nP3gt9rJlq1tmYl3I="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2209/rec_tit/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
